import React from "react";
export const NonVegLabel = ({ enabled }) => (
  <span className={`product-card__label ${enabled ? "product-card__label--green" : "product-card__label--red"}`}>
    <i className="product-card__label_circle" />
  </span>
);
